import { ChangeEvent, useState } from 'react';
import { toast } from 'react-hot-toast';
import { Button } from '../../../../components/ui/Button/Button';
import S from './ActivateFleetModalStyles';
import usePatchAudioSchema from '../../../../API/hooks/devices/usePatchAudioSchema';
import useGetFleetId from '../../../../API/hooks/useGetFleetId';
import { AudioSchema } from '../../../../API/types/AudioSchemas';
import CheckBox from '../../../../components/common/CheckBox/CheckBox';
import usePatchActivateFleetAudioSchema from '../../../../API/hooks/devices/usePatchActivateFleetAudioSchema';
import useGetAudioSchemaFleet from '../../../../API/hooks/devices/useGetAudioSchemaFleet';

type Props = {
  onClose: () => void;
  isFleetActive: boolean;
};

function ActivateFleetModal({
  onClose, isFleetActive,
}: Props): JSX.Element {
  const fleetId = useGetFleetId();
  const [isActive, setIsActive] = useState(isFleetActive);
  const onSubmitSuccess = (): any => {
    toast.success('Fleet setting was applied');
    onClose();
  };
  const onSubmitFail = (errorMessage: string): any => {
    toast.error(`Fleet setting apply was failed: ${errorMessage}`);
    // onClose();
  };
  const { mutate } = usePatchActivateFleetAudioSchema(onSubmitSuccess, onSubmitFail);

  const handleSelectChange = (e: ChangeEvent<any>, state: boolean): void => {
    setIsActive(state);
  };

  return (
    <S.Wrapper>
      <CheckBox
        name="isActive"
        state={isActive}
        label="Schema is active for fleet"
        onChange={handleSelectChange}
      />
      <div className="actions">
        <Button
          padding="7px 40px"
          onClick={() => mutate({
            fleetId,
            isActive,
          })}
        >
          Update
        </Button>
        <Button
          padding="7px 40px"
          onClick={onClose}
        >
          Cancel
        </Button>
      </div>
    </S.Wrapper>
  );
}

export default ActivateFleetModal;
